import { Inject, Injectable, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
	providedIn: 'root',
})
export class DocumentService {

	private window = this.document.defaultView as any;

	constructor(@Inject(DOCUMENT) private document: Document) {
	}

	loadStylesheet(renderer: Renderer2, href: string) {
		return new Promise<void>((resolve, reject) => {
			const style = renderer.createElement('link');
			style.rel = 'stylesheet';
			style.href = href;
			style.onload = () => resolve();
			style.onerror = () => reject(new Error(`Failed to load stylesheet: ${href}`));
			renderer.appendChild(this.document.head, style);
		});
	}

	loadJavascript(renderer: Renderer2, src: string, bypassDefine = false) {
		const define = this.window.define;
		if (bypassDefine) {
			// workaround for preventing errors due to legacy requirejs
			this.window.define = undefined;
		}
		return new Promise<void>((resolve, reject) => {
			const script = renderer.createElement('script');
			script.src = src;
			script.onload = () => resolve();
			script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
			renderer.appendChild(this.document.head, script);
		}).finally(() => {
			if (bypassDefine) {
				this.window.define = define;
			}
		});
	}
}
